import api from "./axios";
import { getErrorMsgAndCode } from "./FrontendHelpers";

export async function GetUserSettings() {
  try {
    const response = await api.get("/getUserSettings");
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function UpdateUserSettings(updates) {
  try {
    const response = await api.post("/setUserSettings", updates);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetCompanySettings() {
  try {
    const response = await api.get("/getCompanySettings");
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function UpdateCompanySettings(updates) {
  try {
    const response = await api.post("/setCompanySettings", updates);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
